/**
 * Which revision of the Disclaimer & Terms of Use the app is serving.
 *
 * One constant, two consumers: the disclaimer page prints it as "Last updated", and both payment
 * surfaces send it with the order so the record says *which* terms the customer accepted — "they
 * agreed to the terms" is worth little if nobody can say which terms those were. The backend
 * stores it on the order and in the audit entry (`_consent` in routers/customer.py).
 *
 * **Change this whenever the wording on that page changes.** Nothing derives it from the text, so
 * the UI suite guards the pairing instead: it hashes the rendered terms and fails if the text
 * moved without this date moving with it (frontend/tests/e2e/routes.mjs).
 */
export const TERMS_VERSION = "2 October 2026";
